import React, { useState, useEffect, useRef } from 'react';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import api from '../service/AxiosInstance';
import moment from 'moment';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

const lineData = {
    labels: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Jul', 'Aou', 'Sept', 'Oct', 'Nov', 'Dec'],
    datasets: [
        {
            label: 'N - 1',
            data: [65, 59, 80, 81, 56, 55, 40],
            fill: false,
            backgroundColor: '#2f4860',
            borderColor: '#2f4860',
            tension: .4
        },
        {
            label: 'N',
            data: [28, 48, 40, 19, 86, 27, 90],
            fill: false,
            backgroundColor: '#00bb7e',
            borderColor: '#00bb7e',
            tension: .4
        }
    ]
};

const Dashboard = (props) => {
    const [products, setProducts] = useState([]);
    const menu1 = useRef(null);
    const menu2 = useRef(null);
    const [lineOptions, setLineOptions] = useState(null);
    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);
    const [compta, setCompta] = useState({});
    const [solde, setSolde] = useState(0);
    const [freels, setFreels] = useState(0);
    const [debit, setDebit] = useState(0);
    const [credit, setCredit] = useState(0);
    const [listDoc, setListDoc] = useState([]);
    const params = useParams();

    // const formatCurrency = (value) => {
    //     return value.toLocaleString('fr-FR');
    // }

    const applyLightTheme = () => {
        const lineOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef',
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef',
                    }
                },
            }
        };

        setLineOptions(lineOptions)
    }

    const applyDarkTheme = () => {
        const lineOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#ebedef'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#ebedef'
                    },
                    grid: {
                        color: 'rgba(160, 167, 181, .3)',
                    }
                },
                y: {
                    ticks: {
                        color: '#ebedef'
                    },
                    grid: {
                        color: 'rgba(160, 167, 181, .3)',
                    }
                },
            }
        };

        setLineOptions(lineOptions)
    }



    const tabDocs = [];

    useEffect(() => {

        api.get("Participant/Miliri/GetSoldePart/" + user_connect.numcont)
            // api.get("Participant/Miliri/GetSoldePart/" + params.num !== undefined ? params.num : user_connect.numcont)
            .then(res => {
                setCompta(res.data);
                setSolde(res.data['solde']);
                setFreels(res.data['freels']);
                setDebit(res.data['debit']);
                setCredit(res.data['credit']);
            });

    }, []);

    useEffect(() => {

        api.get("Document/ByPartExt", {
            params: {
                matricule: user_connect.numcont,
                // matricule: params.num !== undefined ? params.num : user_connect.numcont,
                annee: new Date().getUTCFullYear()
            }
        })
            .then(resp => {
                setListDoc(resp.data);
                tabDocs[0] = resp.data[0];
                tabDocs[1] = resp.data[1];
                tabDocs[2] = resp.data[2];
                tabDocs[3] = resp.data[3];
                tabDocs[4] = resp.data[4];

                setProducts(tabDocs);

            });

    }, []);


    useEffect(() => {
        if (props.colorMode === 'light') {
            applyLightTheme();
        } else {
            applyDarkTheme();
        }
    }, [props.colorMode]);

    const totalDoc = listDoc.length;
    const totalBPI = listDoc.filter(doc => doc.typedoc === 'BPI').length;
    const totalLGI = listDoc.filter(doc => doc.typedoc === 'LGI').length;
    const totalLHI = listDoc.filter(doc => doc.typedoc === 'LHI').length;
    const totalBCI = listDoc.filter(doc => doc.typedoc === 'BCI').length;

    const tauxBPI = ((totalBPI / totalDoc) * 100).toFixed(2);
    const tauxLGI = ((totalLGI / totalDoc) * 100).toFixed(2);
    const tauxLHI = ((totalLHI / totalDoc) * 100).toFixed(2);
    const tauxBCI = ((totalBCI / totalDoc) * 100).toFixed(2);


    const formatCurrency = (value) => {
        return value.toLocaleString('fr-FR');
    };

    const dateDocTemplate = (rowData) => {
        return moment(rowData.datedoc).format("DD-MM-YYYY");
    }


    return (
        <div className="grid">
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block  text-900 font-medium mb-3">Solde</span>
                            <div className="text-900  font-medium text-xl">{formatCurrency(solde)} CFA</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-shopping-cart text-blue-500 text-xl" />
                        </div>
                    </div>
                    {/* <span className="text-green-500 font-medium">24 new </span>
                    <span className="text-500">since last visit</span> */}
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-900 font-medium mb-3">Frais Réels Engagés</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(freels)} CFA</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-map-marker text-orange-500 text-xl" />
                        </div>
                    </div>
                    {/* <span className="text-green-500 font-medium">%52+ </span>
                    <span className="text-500">since last week</span> */}
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-900 font-medium mb-3">Montant Total Dû</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(debit)} CFA</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-cyan-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-inbox text-cyan-500 text-xl" />
                        </div>
                    </div>
                    {/* <span className="text-green-500 font-medium">520  </span>
                    <span className="text-500">newly registered</span> */}
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-900 font-medium mb-3">Total Remboursé</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(credit)} CFA</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-purple-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-comment text-purple-500 text-xl" />
                        </div>
                    </div>
                    {/* <span className="text-green-500 font-medium">85 </span>
                    <span className="text-500">responded</span> */}
                </div>
            </div>

            <div className="col-12 xl:col-6">
                <div className="card">
                    <h5>Documents Récents</h5>
                    <DataTable value={products} responsiveLayout="scroll" resizableColumns rowHover>

                        <Column field="datedoc" header="Date" />
                        <Column field="numdoc" header="Num Doc" />
                        <Column field="beneficiaire" header="Bénéficiaire" />
                        <Column field="fournisseur" header="Prestataire" />

                    </DataTable>
                </div>
                <div className="card">
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>{`Taux de Création de Documents (Total : ${totalDoc})`}</h5>
                        <div>
                            <i className="pi pi-envelope" style={{ 'fontSize': '1em' }}></i>
                        </div>
                    </div>
                    <ul className="list-none p-0 m-0">
                        <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                            <div>
                                <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{`Bons de Pharmacie (${totalBPI})`}</span>
                            </div>
                            <div className="mt-2 md:mt-0 flex align-items-center">
                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{ height: '8px' }}>
                                    <div className="bg-orange-500 h-full" style={{ width: `${tauxBPI}%` }} />
                                </div>
                                <span className="text-orange-500 ml-3 font-medium">{tauxBPI} %</span>
                            </div>
                        </li>
                        <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                            <div>
                                <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{`Lettres de Garantie (${totalLGI})`}</span>
                            </div>
                            <div className="mt-2 md:mt-0 ml-0 md:ml-8 flex align-items-center">
                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{ height: '8px' }}>
                                    <div className="bg-cyan-500 h-full" style={{ width: `${tauxLGI}%` }} />
                                </div>
                                <span className="text-cyan-500 ml-3 font-medium">{tauxLGI} %</span>
                            </div>
                        </li>
                        <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                            <div>
                                <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{`Bons Optique (${totalBCI})`}</span>

                            </div>
                            <div className="mt-2 md:mt-0 ml-0 md:ml-8 flex align-items-center">
                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{ height: '8px' }}>
                                    <div className="bg-pink-500 h-full" style={{ width: `${tauxBCI}%` }} />
                                </div>
                                <span className="text-pink-500 ml-3 font-medium">{tauxBCI} %</span>
                            </div>
                        </li>
                        <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                            <div>
                                <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{`Lettres d'Hospitalisation (${totalLHI})`}</span>

                            </div>
                            <div className="mt-2 md:mt-0 ml-0 md:ml-8 flex align-items-center">
                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{ height: '8px' }}>
                                    <div className="bg-green-500 h-full" style={{ width: `${tauxLHI}%` }} />
                                </div>
                                <span className="text-green-500 ml-3 font-medium">{tauxLHI} %</span>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>

            <div className="col-12 xl:col-6">
                <div className="card">
                    <h5>Consommations Mensuelles</h5>
                    <Chart type="line" data={lineData} options={lineOptions} />
                </div>

                <div className="card">
                    <div className="flex align-items-center justify-content-between mb-4">
                        <h5>Notifications</h5>
                        <div>
                            <i className="pi pi-info"></i>
                        </div>
                    </div>

                    <span className="block text-600 font-medium mb-3">DEPASSEMENT</span>
                    <ul className="p-0 mx-0 mt-0 mb-4 list-none">
                        <li className="flex align-items-center py-2 border-bottom-1 surface-border">
                            <div className="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                                <i className="pi pi-dollar text-xl text-blue-500" />
                            </div>
                            <div>
                                <span className="text-900 line-height-3">Consommation :</span>
                            </div>
                            <div className="mt-2 md:mt-0 ml-0 md:ml-8 flex align-items-center">
                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{ height: '8px' }}>
                                    <div className="bg-green-500 h-full" style={{ width: `${tauxLHI}%` }} />
                                </div>
                                <span className="text-green-500 ml-3 font-medium">{tauxLHI} %</span>
                            </div>

                        </li>

                        <li className="flex align-items-center py-2 border-bottom-1 surface-border">
                            <div className="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                                <i className="pi pi-dollar text-xl text-blue-500" />
                            </div>
                            <div>
                                <span className="text-900 line-height-3">Endettement :</span>
                            </div>
                            <div className="mt-2 md:mt-0 ml-0 md:ml-8 flex align-items-center">
                                <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{ height: '8px' }}>
                                    <div className="bg-blue-500 h-full" style={{ width: `${tauxLHI}%` }} />
                                </div>
                                <span className="text-blue-500 ml-5 font-medium">{tauxLHI} %</span>
                            </div>

                        </li>



                    </ul>


                </div>

            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return (prevProps.location.pathname === nextProps.location.pathname) && (prevProps.colorMode === nextProps.colorMode);
};

export default React.memo(Dashboard, comparisonFn);
